export default {
      id: "deco_titre-usage",
      viewBox: "0 0 25 25",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#deco_titre-usage",
      toString: function () {
        return this.url;
      }
    }